module.exports = __webpack_public_path__ + "static/media/thumb2.66f64492.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/thumb2.jpg
// module id = 641
// module chunks = 0